<template>
  <div class="CovidSalaries" >
    <section id='form-section-banner' :style="{ backgroundImage: 'url(' + require('@/assets/images/masque_banner.jpg') + ')' }">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h1 v-if="typeSalarie == 'PERM'" class="form-section-banner-title">
              Salariés permanents
            </h1>
            <h1 v-if="typeSalarie == 'INTER'" class="form-section-banner-title">
              Intermittents
            </h1>
            <h1 v-if="typeSalarie == 'PIG'" class="form-section-banner-title">
              Journalistes pigistes
            </h1>
          </div>
        </div>
      </div>
    </section>
      <div class="container">
        <div class="form_div">
          <div class="form_content">
              <h2>
                COVID-19, difficultés financières et sociales
              </h2>
              <p>
                Vous trouverez sur cette page l'ensemble des mesures mises en place pour vous soutenir suite à la crise du Covid-19.<br>
                <em>Cliquez sur les mesures pour accéder à leur contenu</em>
              </p>

              <div class="row mt-4">
                <div class="col-12">
                  <ol class="gradient-list">
                    <li>Dépistage :
                      <a class="aide-link" href='https://www.audiens.org/accueil/actualites/actus-audiens/listeactusaudiens/covid-19--effectuez-un-test-serologique-au-pole-sante-bergere.html' target="_blank">
                        Tests sérologiques, tests PCR et antigéniques <strong>Audiens</strong>
                      </a> ou
                      <a class="aide-link" href='mailto:productions.cmb@cmb.asso.fr' target="_blank">
                         Tests antigéniques <strong>CBM en partenariat avec l'APHP</strong>
                      </a>
                    </li>
                    <!--<li>
                      <a class="aide-link" href="https://www.afdas.com/actualites/fne-rebond" target="_blank">
                        <strong>FNE Rebond</strong> : former vos salariés en activité partielle
                      </a>
                    </li>-->
                    <li>
                      <a class="aide-link" href='https://www.afdas.com/offres-formation-distanciel-entreprises-particuliers#des-offres-de-formation-pour-accompagner-la-sortie-de-crise' target="_blank">
                        Référencement d’<strong>offres de formation</strong> pour accompagner la sortie de crise sur 3 dimensions :
                      </a>
                      Prévention et Sécurité - Organisation et managériale - Commerciale et servicielle
                    </li>
                    <li v-if="typeSalarie == 'INTER'">
                      <a class="aide-link" href='https://aide-exceptionnelle-audiens.org/' target="_blank">
                        Aides sociales
                      </a>
                    </li>
                    <li v-if="typeSalarie == 'PERM' || typeSalarie == 'PIG'">
                      <a class="aide-link" href='https://aide-exceptionnelle-audiens.org/' target="_blank">
                        <strong>Aides sociales exceptionnelles</strong>
                      </a>
                    </li>
                    <li>
                      Organisation de
                      <a class="aide-link" href='http://www.cmb-sante.fr/actualit%C3%A9s-cmb-actualit%C3%A9s_241_242.html' target="_blank">
                         <strong>webinaires mensuels</strong>
                      </a> sur des thèmes en lien avec la crise sanitaire
                    </li>
                    <li>
                      <a class="aide-link" href='http://www.cmb-sante.fr/_upload/ressources/01actualites/011actualites_cmb/2020.09.29_faq_maj_22.09.2020.pdf' target="_blank">
                        <strong>FAQ spéciale COVID-19</strong>
                      </a>
                    </li>
                    <li>
                      <a class="aide-link" href='mailto:covid-psychosocial@cmb.asso.fr' target="_blank">
                        Cellule pluridisciplinaire  <strong>de soutien psychosocial COVID</strong>
                      </a>
                    </li>
                    <li>
                      <a class="aide-link" href='https://www.audiens.org/solutions/garanties-assistance-24h24-et-7j7.html' target="_blank">
                        Cellule d'écoute psychologique COVID pour les <strong>assurés en santé Audiens</strong>
                      </a>
                    </li>
                    <li>
                      <a class="aide-link" href='https://www.audiens.org/accueil/actualites/actus-audiens/listeactusaudiens/aidants-familiaux-une-plateforme-d-ecoute-psychologique-a-votre-disposition.html' target="_blank">
                        Cellule d'écoute psychologique pour les <strong>aidants familiaux</strong>
                      </a>
                    </li>
                  </ol>
                </div>
              </div>

              <b-button @click="goToOtherSalaries" size="lg" pill block variant="outline-primary">Accéder à vos autres services partagés</b-button>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CovidSalaries',
  computed: {
    typeSalarie: {
      get () {
        return this.$store.state.characteristics.typeSalarie
      },
    },
  },
  methods: {
    goToOtherSalaries () {
      this.$router.push('/autre/salaries')
    },
  }
}
</script>

<style lang="scss">
/*** EXTEND ***/
/* box-shadow */
%boxshadow {
  box-shadow: 0.25rem 0.25rem 0.6rem rgba(0,0,0,0.05), 0 0.5rem 1.125rem rgba(75,0,0,0.05);
}

/*** STYLE ***/

*,
*:before,
*:after {
  box-sizing: border-box;
}

.aide-link {
  text-decoration: none;
}



ol.gradient-list {
  counter-reset: gradient-counter;
  list-style: none;
  margin: 1.75rem 0;
  padding-left: 1rem;
  > li {
    background: white;
    border-radius: 0 0.5rem 0.5rem 0.5rem;
    @extend %boxshadow;
    counter-increment: gradient-counter;
    margin-top: 1rem;
    min-height: 2rem;
    padding: 1rem 1rem 1rem 3rem;
    position: relative;
    &::before,
    &::after {
      background-color: #d6075b;
      content: '';
      height: 2rem;
      left: -0.5rem;
      overflow: hidden;
      position: absolute;
      top: -0.5rem;
      width: 2rem;
    }
    &::before {
      align-items: flex-end;
      @extend %boxshadow;
      content: counter(gradient-counter);
      color: #1d1f20;
      display: flex;
      font-weight: 800;
      color: white;
      justify-content: flex-end;
      padding: 0.23em 0.7em;
      z-index: 1;
    }

    + li {
      margin-top: 2rem;
    }
  }
}


</style>
